<template>
  <dy-dialog v-model="visible" width="80%" title="选择费用标准" confirm-title="确定" :show-confirm="!!selectRow"
             @onConfirm="handleSelected" @onClose="handleClose">
    <dy-main-container class="select-asset-dialog" hide-top-menu>
      <template #left>
        <DyOrgManagement
          ref="leftTreeRef"
          :table-list-api="api.getChargeAccountTypeTree"
          data-path="data"
          @onchange="handleOrgSelected"
          :width="dividerOption.leftAsideWidth"
          :table-columns="tableColumns"
          :default-select="false"
        />
      </template>
      <template #right>
        <avue-crud ref="crud" :page.sync="page" :data="tableList" :table-loading="tableLoading" :option="standardOption"
                   @search-change="searchChange" @row-click="rowClick" @on-load="getList">
          <template slot="radio" slot-scope="{row}">
            <el-radio v-model="selectRowIndex" :label="row.$index">&nbsp;</el-radio>
          </template>
        </avue-crud>
      </template>
    </dy-main-container>
  </dy-dialog>
</template>

<script>
import DyDialog from "@/components/DYDialog/index.vue";
import DyMainContainer from "@/components/DYMainContainer/index.vue";
import {getTableOption} from '@/const/crud/charge/standard/company';
import {getChargeAccountTypeTree} from "@/api/v3/finance/account/type";
import {getChargeStandardList} from "@/api/v3/finance/conduct/company";
import {mapGetters} from "vuex";
import store from "@/store";

export default {
  name: 'DySelectConductDialog',
  components: {DyMainContainer, DyDialog},
  data() {
    return {
      visible: false,
      assetType: 0,
      orgInfo: undefined,
      selectRow: undefined,
      selectRowIndex: undefined,
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      dividerOption: {
        leftAsideWidth: 225,
        leftAsideMinWidth: 200
      },
      searchForm: {},
      api: {
        getChargeAccountTypeTree: () => getChargeAccountTypeTree({includeAccount: true, includeValid: true}),
      },
      standardOption: undefined,
      tableList: undefined,
      tableLoading: false,
      tableColumns: [
        {
          label: '名称',
          prop: 'name',
          width: '70',
          mainColumn: true,
        },
      ],
    }
  },
  computed: {
    project() {
      return store.getters.project
    }
  },
  methods: {
    open(params) {
      const {searchParams, resolve, cancel} = params || {}
      this.resolve = resolve
      this.cancel = cancel
      this.extraSearchParams = searchParams
      this.resolve = resolve
      this.orgInfo = undefined
      this.searchForm = {}
      this.tableList = []
      this.selectRow = undefined
      this.selectRowIndex = undefined
      this.page.currentPage = 1
      const standardOption = getTableOption()
      standardOption.menu = false
      standardOption.height = 380
      standardOption.index = false
      // const columns = ['收费标准编码', '收费标准名称', '收费科目', '计算方式', '收费标准(元)', '启用日期']
      standardOption.column.forEach(item => {
        item.width = 150
        if (['name', 'chargeType'].includes(item.prop)) {
          item.width = 250
        }
        if (!['conductName', 'chargeType'].includes(item.prop)) {
          item.search = false
        }
      })
      standardOption.column.unshift({
        prop: 'radio',
        width: 60,
      })
      this.standardOption = standardOption
      this.visible = true
    },
    handleOrgSelected(org) {
      if (!org?.code) return
      this.orgInfo = org
      this.page.currentPage = 1
      this.selectRow = undefined
      this.selectRowIndex = undefined
      this.getList()
    },
    searchChange(form, done) {
      this.searchForm = form
      this.page.currentPage = 1
      this.getList()
      done()
    },
    async getList() {
      this.tableLoading = true
      const selectedAccountCode = this.orgInfo?.code || this.extraSearchParams?.accountCode
      const form = {
        ...this.searchForm,
        page: this.page.currentPage,
        limit: this.page.pageSize,
        projectCode: this.project.code,
        ...this.extraSearchParams,
        groupAccountCode: selectedAccountCode,
        accountCode: selectedAccountCode
      }
      const res = await getChargeStandardList(form)
      this.tableList = res.data.records
      this.page.total = Number(res.data.total)
      this.selectRow = undefined
      this.selectRowIndex = undefined
      this.tableLoading = false
    },
    handleSelected() {
      this.visible = false
      this.$emit('confirm', this.selectRow)
      this.resolve && this.resolve(this.selectRow)
    },
    handleClose() {
      this.selectRow = undefined
      this.selectRowIndex = undefined
      this.cancel && this.cancel()
    },
    rowClick(row) {
      this.selectRow = row
      this.selectRowIndex = row.$index
    }
  }
}
</script>

<style scoped lang="scss">

.select-asset-dialog {
  height: 515px;
  overflow: hidden;
}

::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid rgba(236, 236, 236, 0.89);
  }

  .el-dialog__footer {
    border-top: 1px solid rgba(236, 236, 236, 0.89);
  }

  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
